require("./components/bootstrap");
import mixin from "./components/mixin.js";
import member from "./components/member.js";

var eatizenRegister = new Vue({
  el: "#app",
  mixins: [mixin, member],
  data: {
    loginData: {
      mobilePhone: eatizenMobile,
      password: "",
    },
    showPassword: false,
    step: 1,
    registerData: {
      birthDay: "",
      birthMonth: "",
      emailAddress: "",
      masterId: "",
      memberId: "",
      octopusId: "",
      yuuId: "",
      mobilePhone: "",
      receiveMessage: 0,
    },
    prefillInfo : prefillInfo ? prefillInfo : [],
    showYuu: false,
    showMonth: false,
    showDay: false,
    monthNames: [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ],
    months: {
      1: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
      2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29],
      3: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
      4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
      5: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
      6: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
      7: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
      8: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
      9: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
      10: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
      11: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
      12: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
    },
    days: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
    agree: 0,
    invalidMsg: {
      birthDay: "",
      birthMonth: "",
      familyName: "",
      givenName: "",
      mobilePhone: "",
      password: "",
      password_confirmation: "",
      emailAddress: "",
      octopusId: "",
    },
    yuu: {
      popupShow: true,
      linked: false,
      inputYuuId: "",
      locked: false,
      unlinking: false,
      loginRequired: false,
      login: false,
      loginUrl: "",
      popupLoginWindow: false,
      loginWindow: {},
    },
  },
  watch: {
    "loginData.mobilePhone": function (val) {
      this.loginData.mobilePhone = this.restrictMobile(val);
    },
    "registerData.octopusId": function (val) {
      this.registerData.octopusId = this.restrictOctopus(val);
    },
    "registerData.yuuId": function (val) {
      this.registerData.yuuId = this.restrictYuu(val);
    },
    "registerData.birthMonth": function (val) {
    },
  },
  computed: {
    showMobile: function () {
      return this.validateMobile(this.loginData.mobilePhone);
    },
  },
  mounted() {
    let self = this;
    if (eatizenMobile) {
      this.loginData.mobilePhone = eatizenMobile
    }
    this.autoFillIn();
    $(function () {
      self.collapse();
    });
  },
  methods: {
    autoFillIn(){
      for (const [key, value] of Object.entries(this.prefillInfo)) {
        this.registerData[key] = value;
      }
    },
    login: async function () {
      const result = await this.memberApi(
        "/member/register/eatizen/login",
        this.loginData
      );
      if (result.status) {
        this.step = 2;
        this.registerData = result.data;
        this.registerData.mobilePhone = this.loginData.mobilePhone;

        //eatizen* member doesn't have yuu id
        if (!this.registerData.yuuId) this.registerData.yuuId = this.prefillInfo.yuuId;

        if (this.registerData.yuuId){
          this.yuu.linked = true;
          this.yuu.popupShow = false;
          this.yuu.inputYuuId = this.registerData.yuuId;
        }
      } else {
        this.showAlert("", result.message);
      }
    },
    updateYuuId: async function (validation = false) {
      let self = this;

      //loading
      if (this.loading) {
        return;
      }

      // validation
      if (validation && !this.validationYuuId()) {
        return;
      }

      const result = await this.memberApi("/member/register/yuu/check", {
        yuuId: this.yuu.inputYuuId,
        page: 1,
      });
      if (result.status) {
        //update popup
        this.yuu.linked = true;
        this.yuu.popupShow = false;
        this.registerData.yuuId = this.yuu.inputYuuId;
      } else {
        this.showAlert("", result.message);
        self.yuu.inputYuuId = "";
      }
      self.loading = false;
    },
    unlinkYuuId() {
      this.yuu.inputYuuId = "";
      this.yuu.linked = false;
      this.yuu.popupShow = false;
      this.yuu.unlinking = false;
      this.registerData.yuuId = "";
    },
    validationYuuId() {
      //check yuu id length and prefix
      if (this.yuu.inputYuuId.length != 15 || !this.yuu.inputYuuId.startsWith('934480')) {
        let errorMessage = {
          en: 'Invalid yuu ID',
          tc: 'yuu ID 無效'
        };
        this.showAlert(null, errorMessage[this.lang]);
        return false;
      }
      //empty
      if (this.yuu.inputYuuId == "") {
        let errorMessage = {
          en: "Yuu Id can not be empty",
          tc: "Yuu Id 不可以是空",
        };
        this.showAlert("", errorMessage[this.lang]);
        return false;
      }

      return true;
    },
    collapse() {
      // collapse
      $(".collapse-head").click(function () {
        let thisdata = JSON.parse($(this).attr("data-show"));
        if (thisdata == false) {
          $(this)
            .parents(".collapse-item")
            .find(".collapse-cont")
            .slideDown();
          $(this).addClass("slidedown");
          $(this).attr("data-show", "true");
        }
        if (thisdata == true) {
          $(this)
            .parents(".collapse-item")
            .find(".collapse-cont")
            .slideUp();
          $(this).removeClass("slidedown");
          $(this).attr("data-show", "false");
        }
      });

      $(document).mousedown(function (e) {
        if ($(e.target).closest(".month-row").length === 0) {
          $(".month-row").hide();
        }

        if ($(e.target).closest(".day-row").length === 0) {
          $(".day-row").hide();
        }
      });

      $(".option-item").click(function (e) {
        let $this = $(this);
        let selectItem = $this.parents(".show-dropdown").find(".select-title");
        let value = $this.find(".selectitem-txt").text();
        e.stopPropagation();
        $this.addClass("active");
        $this.siblings().removeClass("active");
        selectItem.text(value).css("color", "#E0771F");
        setTimeout(() => {
          $this.parents(".dropdown-wrap").slideUp();
        }, 500);
      });

      $(".option-item-cont").click(function (e) {
        var $this = $(this);
        var selectItem = $this.parents(".show-dropdown").find(".select-title");
        var value = $this.find(".selectitem-txt").text();
        e.stopPropagation();
        $this.addClass("active");
        $this.siblings().removeClass("active");
        selectItem.text(value).css("color", "#3E1707");
        setTimeout(function () {
          $this.parents(".dropdown-wrap").slideUp();
        }, 500);
      });
    },
    checkYuuDuplicate: async function () {
      const request = {
        yuuId: this.registerData.yuuId,
        memberId: this.registerData.memberId,
        page: "eatizenRegistration",
      };
      const result = await this.memberApi(
        "/member/register/yuu/check",
        request
      );
      if (result.status) {
        this.showYuu = false;
      } else {
        this.showAlert("", result.message);
        this.registerData.yuuId = "";
      }
    },
    register: async function () {
      if (!this.agree) {
        this.showAlert("", agreeError);
        return false;
      }
      const result = await this.memberApi(
        "/member/register/eatizen",
        this.registerData
      );
      if (result.status) {
        showSingleConfirmAlert("", registerSuccessMessage, registerSuccessButtonMessage, '', () => {
          window.location = homepage;
        })
      } else {
        this.showAlert("", result.message);
        this.resetRegisterData();
        this.step = 1;
      }
    },
    resetRegisterData() {
      this.registerData = {
        birthDay: "",
        birthMonth: "",
        emailAddress: "",
        masterId: "",
        memberId: "",
        octopusId: "",
        yuuId: "",
        mobilePhone: "",
        receiveMessage: 0,
      };
    },
    updateBirthDay(i) {
      i = parseInt(i);
      this.registerData.birthDay = i;
    },
    resetBirthDay(){
      this.registerData.birthDay = "";
    },
    updateBirthMonth(i) {
      i = parseInt(i);
      this.resetBirthDay();
      this.registerData.birthMonth = i;
    },
    showMonthRow() {
      if ($(".month-row").is(":visible")) {
        $(".month-row").hide();
      } else {
        $(".month-row").show();
      }
    },
    showDayRow() {
      if ($(".day-row").is(":visible")) {
        $(".day-row").hide();
      } else {
        $(".day-row").show();
      }
    },
    validationForm() {
      //empty
      this.resetInvalidMessage();
      let valid = true;
      let errorMessage = "";

      if (this.registerData.birthMonth == "") {
        this.invalidMsg.birthMonth = birthdayError;
        errorMessage += (errorMessage ? '<br>' : '') + birthdayError;
        valid = false;
      }

      if (this.registerData.birthDay == "") {
        this.invalidMsg.birthDay = birthdayError;
        errorMessage += (errorMessage ? '<br>' : '') + birthdayError;
        valid = false;
      }

      if (this.registerData.emailAddress != '' && !this.validateEmail(this.registerData.emailAddress)) {
        this.invalidMsg.emailAddress = emailError;
        errorMessage += (errorMessage ? '<br>' : '') + emailError;
        valid = false;
      }
      //Octopus Check
      if (this.registerData.octopusId != '' && this.registerData.octopusId.length < 9 ){
        errorMessage += (errorMessage ? '<br>' : '') + octopusError;
        valid = false;
      }

      if (errorMessage.length > 0) {
        this.showAlert("", errorMessage);
      }
      return valid;
    },
    resetInvalidMessage() {
      for (const [key, value] of Object.entries(this.invalidMsg)) {
        this.invalidMsg[key] = "";
      }
    },
    changeToTerms() {
      if (this.validationForm()) this.step = 3;
    },
  },
});
